import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ id: number }>,
) => {
  const { id } = payloadAction.payload;

  const copy = { ...state.catalogs.data };
  delete copy[id];

  state.catalogs.data = copy;
};

export default action;
